<script setup>
</script>

<script>
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { userApi } from "@/api";
// import LoadingIcon from "@/components/LoadingIcon.vue";

export default defineComponent({
  name: "Login",
  // components: {
  //   LoadingIcon,
  // },
  data() {
    return {
      form: {
        username: "",
        password: "",
        twv_code: "",
      },
      isLoading: false,
      isInvalid: false,
      isTimeOver: false,
      isOtpCodeErr: false,
      showSessionExpiredHint: false,
    };
  },
  mounted() {
    const query = this.$route?.query || {};
    const { reason, ...restQuery } = query;
    this.showSessionExpiredHint = reason === "session_expired";
    if (this.showSessionExpiredHint) {
      this.$router.replace({ path: this.$route.path, query: restQuery }).catch(() => {});
    }
  },

  methods: {

    ...mapActions(["logIn_forwriting"]),

    async log_in( username, password) {
      console.log( "log_in( )...")

      const User = new FormData();
      User.append("username", username);
      User.append("password", password);

      // Otp認証関連(on pass password)
      let isOtpUser = false;
      try {
        const resp = await userApi.isOtpUser( username);
        if (resp && resp.data !== undefined) {
          isOtpUser = resp.data;
        }
      } catch (error) {
        console.error("Error checking OTP user:", error);
        // 如果檢查 OTP 用戶失敗，假設不是 OTP 用戶，繼續登錄流程
        isOtpUser = false;
      }
      
      if (isOtpUser) {
        await this.otpUserCheck(User);
      }
      else {
        try {
          await userApi.loginWithId(User);
          // 登錄成功，繼續後續流程
          await this.logIn_forwriting();
          await this.checkAuthenticated();
        }
        catch (error) {
          console.error("loginWithId() error: ", error);
          this.isLoading = false;

          if (error.response && error.response.data) {
            switch (error.response.data.detail) {
              case "Not White List Ip":
                await this.showIpErrModal();
                return;

              case "Incorrect username or password":
                this.isInvalid = true;
                return;

              default:
                this.isInvalid = true;
                return;
            }
          } else {
            // 如果沒有 response，可能是網絡錯誤
            console.error("Network error during login:", error);
            this.isInvalid = true;
            return;
          }
        }
      }
    },

    async submit() {
      this.form.twv_code = "";
      this.isOtpCodeErr = false;
      this.isTimeOver = false;
      this.isInvalid = false;

      this.isLoading = true
      const username = this.form.username
      const password = this.form.password
      await this.log_in(username, password)
      this.isLoading = false
    },

    async otpUserCheck(User) {
      try {
        await userApi.UserCheck(User);
      }

      catch (error) {
        if (error.response && error.response.data) {
          switch (error.response.data.detail) {
            case "Not White List Ip":
              await this.showIpErrModal();
              break;

            default:
              this.isInvalid = true;
          }
        } else {
          // 如果沒有 response，可能是網絡錯誤
          console.error("OTP user check error:", error);
          this.isInvalid = true;
        }
        console.log(error);
        return;
      }

      finally {
        this.isLoading = false;
      }

      document.getElementById("showModalBtn").click();
    },

    async checkOtp() {
      const User = new FormData();
      User.append("username", this.form.username);
      User.append("password", this.form.password);
      User.append("client_secret", this.form.twv_code);

      this.isLoading = true;

      try {
        await userApi.login(User);
        await this.logIn();
      }
      catch (error) {
        switch (error.response.data.detail) {
          case "Time Over":
            this.isOtpCodeErr = false;
            this.isTimeOver = true;
            break;
          case "Empty Otp Data":
            this.isOtpCodeErr = false;
            this.isTimeOver = true;
            break;
          case "Not White List Ip":
            this.showIpErrModal();
            break;
          default:
            this.isOtpCodeErr = true;
            break;
        }
        this.isLoading = false;
        return;
      }
      document.getElementById("BtnModalClose").click();
      this.isLoading = false;

      await this.checkAuthenticated();
    },

    async checkAuthenticated() {
      if (!this.$store.getters.isAuthenticated) {
        Object.assign(this.$data, this.$options.data());
        this.isInvalid = true;
      }
      else {
        this.$router.push("/forwriting/article_lists");
      }
    },

    async showIpErrModal() {
      document.getElementById("BtnModalClose").click();
      document.getElementById("showIpErrBtn").click();
    },
  },
});
</script>

<template>
  <div class="page-wrapper">
    <div class="container d-flex align-items-center justify-content-center">
      <div class="login-container card text-dark bg-light border-dark shadow rounded">
        <div class="card-body" style="text-align: center;margin-top: 10px">

        <div class="login-section" style="margin-left: 80px">
          <div v-if="showSessionExpiredHint" class="alert alert-warning py-2 text-start" role="alert">
            {{ $t('LogIn.session_expired_hint') }}
          </div>

          <h5 style="margin-left: -8px; margin-top: 10px;">
            <img src="/img/vectorflux_log_with_name-04.png" alt="..." height="40"
            style="margin-top: -8px"> for Writing
          </h5>

          <!-- <button type="submit"
                  style="color: rgb(150, 150, 150); background-color: white; border-color: rgb(205,205,205)"
                  class="btn btn-primary btn-submit">
            Sign in with Google</button> -->

          <hr style="margin-top: 25px">

          <form @submit.prevent="submit" class="needs-validation"
                style="margin-top: 30px">

            <div class="mb-3">
              <label class="form-label" style="text-align: left">
                {{$t('LogIn.email')}}</label>
              <input type="text" placeholder="Your email address"
                     :class="{ 'is-invalid': isInvalid }"
                     v-model="form.username"
                     class="form-control" />

              <div class="invalid-feedback">
                {{ $t('LogIn.invalid_username_or_password') }}</div>
            </div>

            <div class="mb-3">
              <label for="password" class="form-label" style="text-align: left">
                {{$t('LogIn.password')}}</label>
              <input type="password" name="password" placeholder="Your password"
                     v-model="form.password" class="form-control" />
            </div>

            <button type="submit" style="margin-top: 10px"
                    class="btn btn-primary btn-submit"
                    @click="login"
                    :disabled="isLoading">
              {{$t('LogIn.login')}}</button>

          </form>

          <!-- サインインページへのリンク -->
          <div class="mt-3 text-center">
            <p class="mb-2">{{ $t('LogIn.no_account_yet') }}</p>
            <router-link to="/forwriting/signin">
              {{ $t('LogIn.go_to_signin') }}
            </router-link>
          </div>

          <!-- <div class="mt-3 text-center">
            <router-link to="/forwriting/service" class="text-decoration-none">
              サービス詳細を見る
            </router-link>
          </div> -->
<!-- 
            <div style="margin-top: 20px">
              <a href="">{{$t('LogIn.send_link')}}</a>
            </div>
            <div style="margin-top: 10px">
              <a href="">{{$t('LogIn.forget_password')}}</a>
            </div>
            <div style="margin-top: 10px">
              <a href="">{{$t('LogIn.to_sign_up')}}</a>
            </div> -->
        </div>

        <!-- ２段階認証Modal -->
        <button id="showModalBtn" data-bs-toggle="modal" data-bs-target="#OtpModal" style="display:none;"></button>
        <div class="modal fade" id="OtpModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
             aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="OtpModalLabel">{{ $t('LoginView.modal_title') }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <div>{{ $t('LoginView.otp_msg') }}</div>
                  <br>
                  <label for="OtpCode" class="form-label">{{ $t('LoginView.modal_body') }}</label>
                  <input type="text" name="OtpCode" v-model="form.twv_code" class="form-control" />
                  <br>
                  <div class="text-danger">
                    <p v-if="isOtpCodeErr">{{ $t('LoginView.invalid_otp_code_1') }}</p>
                    <p v-if="isTimeOver">{{ $t('LoginView.invalid_otp_code_2') }}</p>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" id="BtnModalClose" class="btn btn-secondary" data-bs-dismiss="modal">
                  {{ $t('LoginView.close_btn') }}
                </button>
                <button type="button" class="btn btn-primary" :disabled="isLoading" @click="checkOtp()">
                  {{ $t('LoginView.send_btn') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- IP制限エラー表示Modal -->
        <button id="showIpErrBtn" data-bs-toggle="modal" data-bs-target="#IpErrModal" style="display:none;"></button>
        <div class="modal fade" id="IpErrModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
             aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="IpModalLabel">{{ $t('LoginView.ip_modal_title') }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <div class="text-danger">
                    <div>{{ $t('LoginView.ip_err_1') }}</div>
                    <div>{{ $t('LoginView.ip_err_2') }}</div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" id="BtnIpModalClose" class="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        </div>
      </div>
    </div>

    <!-- フッター -->
    <footer class="footer py-3 bg-white text-dark border-top">
      <div class="container">
        <div class="d-flex justify-content-center align-items-center gap-4">
          <a href="https://git-house.com/" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
            {{ $t('LogIn.provider') }}
          </a>
          <router-link to="/forwriting/specific-commercial-transaction" class="text-decoration-none">
            {{ $t('LogIn.commercial_transaction') }}
          </router-link>
          <router-link to="/forwriting/privacy-policy" class="text-decoration-none">
            {{ $t('LogIn.privacy_policy') }}
          </router-link>
        </div>
      </div>
    </footer>
  </div>

</template>

<style scoped>
body {
  background-color: #f4f4f4;
}

.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
}

.footer {
  margin-top: auto;
}

.login-container {
  height: 500px;
  width: 435px;
}

.login-section {
  max-width: 240px;
  width: 100%;
  text-align: center;
}

.btn-submit {
  margin-top: 10px;
  width: 100%;
}
</style>